export default __webpack_public_path__ + "static/media/Raupe.ec7f9db3.webp";